// import { io } from 'socket.io-client';

// const backAppURL = config.SOCKET_URL;

// const URL = backAppURL;

// export const socket = io(URL, {
//   transports: ['websocket'],
//   reconnection: true,
//   reconnectionAttempts: Infinity,
//   reconnectionDelay: 1000,
//   reconnectionDelayMax: 5000,
//   randomizationFactor: 0.5
// });

import { io } from 'socket.io-client';
import { decodeToken } from '../utils/jwtUtils';
import config from '../config';

const backAppURL = config.SOCKET_URL; // Initialize backAppURL first

const token = JSON.parse(localStorage.getItem('callex-token'));
const user = token ? decodeToken(token) : null;

const loginUserType =
  user?.type === 'User' || user?.type === 'supervisor' || user?.type === 'TenantAdmin';

const commonSocketOptions = {
  transports: ['websocket'],
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  randomizationFactor: 0.5
};

const socketOptions = loginUserType ? commonSocketOptions : { transports: ['websocket'] };

let socket = io(backAppURL, socketOptions);

export const initializeSocket = () => {
  socket = io(backAppURL, socketOptions);
  return socket;
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    console.log('Socket disconnected');
  }
  socket = null;
};

export { socket };
